app.factory(
    'LocalStorage', [function () {
        return {
            set : function (key, value) {
                localStorage[key] = value;
            },
            get : function (key, defaultValue) {
                return localStorage[key] || defaultValue;
            },
            setObject : function (key, value) {
                localStorage[key] = JSON.stringify(value);
            },
            getObject : function (key) {
                return JSON.parse(localStorage[key] || '{}');
            },
            /**
             * Remove item in local storage
             * @param key
             */
            unsetObject : function (key) {
                localStorage.removeItem(key);
            },
            /**
             * Check wether object exists or not in localStorage
             * @param key
             * @returns {boolean}
             */
            objectExists : function (key) {
                return undefined !== localStorage[key];
            },
            /**
             * Verify if object in localStorage is empty
             * @param key
             * @returns {*}
             */
            isEmpty : function (key) {
                return $.isEmptyObject(localStorage[key]);
            }
        }
    }]
);